import { Swiper } from 'swiper'
import { Navigation } from 'swiper/modules'

function initParticipantsSlider() {
  new Swiper('.js-participantsSlider', {
    loop: true,
    modules: [Navigation],
    slidesPerView: 1,
    autoHeight: true,
    spaceBetween: 32,
    navigation: {
      nextEl: '.participants-button-next',
      prevEl: '.participants-button-prev',
    },
  })
}

initParticipantsSlider()

$(document).on('triggerParticipantsSlider', () => {
  initParticipantsSlider()
})
